<template>
  <div id="modelList">
    <div v-if="models.length">
      <div class="model-list-wrapper">
        <ModelCard
            v-for="(model) in models"
            :key="model.id"
            :model="model"
        />

        <div class="load-more-trigger" v-observe-visibility="loadMore"></div>
      </div>
    </div>
    <div v-else class="no-models">No Product Models Found</div>
  </div>
</template>

<script>
import ModelCard from '@/components/ModelCard.vue'

export default {
  name: 'SearchResults',
  components: {
    ModelCard
  },
  props: {
    models: Array
  },
  emits: ['loadMore'],
  methods: {
    loadMore: function (isVisible) {
      if (isVisible) {
        this.$emit('loadMore')
      }
    }
  }
}
</script>
